<template>
  <div class="album-footer" :class="{ 'large-footer': size == 'large' }">
    <!-- <div class="footer-modal"></div> -->
    <div class="user-operation" v-if="currentResourceInfo && size == 'mini'">
      <collectBtn
        :collected="currentResourceInfo.isFavorite"
        @modifyCollectedState="modifyCollectedState"
        @toLogin="toLogin"
        :documentId="documentId"
        @collectBtnDialog="collectBtnDialog"
        :userLoginStatus="loginStatus"
        :userRoleStatus="roleStatus"
      />
      <span class="tiaocuo-btn" data-io-click="tracker"  @click.stop="handleFeedbackDialogVisible(true)">
        <i class="iconfont icon-edit"></i><span>挑错</span>
      </span>
    </div>
    <div class="document-operation-btn">
      <div class="document-group-btn" v-if="currentResourceInfo">
        <el-tooltip
          class="item"
          effect="dark"
          content="加入备课的资源可前往【备课空间】进行管理"
          placement="top"
          v-model="showAddBkTip"
          :value="firstShowAddBkTip"
          v-if="currentResourceInfo.isShowAdd"
        >
          <div slot="content">
            <div class="bk-tip-box">
              <!-- v-if="showBkTip" -->
              <transition name="run">
                <div class="add-bk-tip" v-if="!firstShowAddBkTip">
                  资料加入【备课空间】存储至
                  <span class="text" v-if="chooseNode">{{
                    chooseNode.folderName
                  }}</span>
                  <span class="check-btn" data-io-click="tracker"  @click.stop="handleShowFileTree"
                    >切换</span
                  >
                </div>
              </transition>
            </div>
          </div>
          <div
            class="bk-btn document-btn add-bk-btn"
            data-io-click="tracker"  @click="handleAddBk"
            @mouseenter="handleAddBkTip"
            v-if="currentResourceInfo.isShowAdd"
          >
            加入备课
          </div>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          v-if="currentResourceInfo.isShowEdit"
          content="支持对该资料进行在线编辑"
          placement="bottom"
        >
          <div class="bk-btn document-btn edit-btn" data-io-click="tracker"  @click="handleEdit">
            在线编辑
          </div>
        </el-tooltip>
        <div
          class="document-btn download-btn"
          data-io-click="tracker"  @click="handleDownloadSoft"
          v-if="!currentResourceInfo.isDisableDownLoad"
        >
          <div class="top-tag" v-if="currentResourceInfo.advancedPrice">
            节省{{ currentResourceInfo.advancedPrice }}元
          </div>
          免费下载
        </div>
      </div>
    </div>
    <div v-if="addLectureUrl" class="bk-add-lecture">
      <iframe
        id="addLectureIframe"
        width="100%"
        height="100%"
        frameborder="no"
        border="0"
        allowtransparency="yes"
        :src="addLectureUrl"
        :class="{ 'bk-loaded': isLoaded }"
      ></iframe>
      <i v-if="!isLoaded" class="el-icon-loading"></i>
    </div>
  </div>
</template>
<script>
import api from "@/assets/js/service/api";
import collectBtn from "@/components/collectBtn";
import feedBackModal from "@/components/feedBackModal";
import { beikeHost, getUserFolderLastSelected } from "@/utils/apis";
import request from "@/utils/request";
import { mapMutations, mapState } from "vuex";
const SHOW_ADD_BK_TIP = "SHOW_ADD_BK_TIP";
// 是否第一次加入备课
const FIREST_ADD_BK = "FIREST_ADD_BK";
export default {
  inject: ["textbook"],
  components: {
    feedBackModal,
    collectBtn,
  },
  props: {
    size: {
      type: String,
      default: "mini",
    },
    data: {
      type: Object,
      default: null,
    },
    previewIndex: {
      type: Number,
      default: 0,
    },
    loginStatus: {
      type: Boolean,
      default: false,
    },
    roleStatus: {
      type: Boolean,
      default: false,
    },
    documentId: {
      type: [String, Number],
      default: "",
    },
  },
  computed: {
    ...mapState({
      userCourses: "userCourses",
    }),
  },
  watch: {
    data: {
      handler(val) {
        if (val) {
          if (val) {
            // console.log("---val", val);
            this.currentResourceInfo =
              val.albumResourceDoList && val.albumResourceDoList.length > 0
                ? val.albumResourceDoList[this.previewIndex]
                : null;
            this.getBkInfo();
          }
        }
      },
      immediate: true,
    },
    previewIndex: {
      handler(val) {
        this.currentResourceInfo =
          this.data &&
          this.data.albumResourceDoList &&
          this.data.albumResourceDoList.length > 0
            ? this.data.albumResourceDoList[val]
            : null;
      },
    },
  },
  data() {
    return {
      // 当前资源信息
      currentResourceInfo: null,
      showAddBkTip: false,
      // 显示添加备课提示
      firstShowAddBkTip: false,
      chooseNode: null,
      // 空间信息
      spaceCapacity: null,
      // 添加备课地址
      addLectureUrl: "",
      isLoading: false,
    };
  },
  mounted() {
    this.initMessage();
    // this.initAddBkTipStatus()
  },
  methods: {
    ...mapMutations(["changeShowAddBkTip"]), //打开详情页展示的设置页面
    handleAddBkTip() {
      this.firstShowAddBkTip = false;
      this.changeShowAddBkTip(false);
    },
    async handleAddBk(needPay = true) {
      if (!this.loginStatus) {
        this.toLogin();
        return;
      }
      if (!this.roleStatus) {
        this.$emit("handleShowDownloadErrorVisible", {
          status: true,
          message:
            "亲爱的用户，您的账号暂无网校通权限。请您确认账号信息是否正确，并与学校管理员联系以获取更多帮助",
        });
        return;
      }
      if (this.isLoading) return;
      let isFirstAddBk = localStorage.getItem(FIREST_ADD_BK) || false;
      if (this.showBkTip) {
        this.changeShowAddBkTip(false);
      }
      // console.log("----isFirstAddBk", isFirstAddBk);
      if (!isFirstAddBk) {
        // this.showFileTree = true;
        this.initAddLecture();
        localStorage.setItem(FIREST_ADD_BK, true);
        this.textbook.noticeParentPageShowMask(true);
        // console.log("lastSelectedFolder", lastSelectedFolder);
        // console.log("bkFolders", bkFolders);
      } else {
        console.log("切换");
        // this.showBkTip = !this.showBkTip;
        // console.log("chooseNode", this.chooseNode);
        this.handleSubmit(
          this.chooseNode.folderId,
          this.chooseNode.folderName,
          !needPay
        );
      }
      // 直接显示切换目录提示框
    },
    initMessage() {
      let vm = this;
      window.addEventListener("message", function (e) {
        if (!e.data || typeof e.data != "string") {
          return;
        }
        let message = JSON.parse(e.data);
        // console.log("footer----message----", message);
        let { type, data, params } = message;
        // console.log("---message--", message);
        if (type) {
          if (type === "getAddLectureParams") {
            const param = {
              key: "bk",
              type: "addLecture",
              from: "wxt",
              params: {
                courseId: vm.currentResourceInfo.courseId,
              },
            };
            document
              .getElementById("addLectureIframe")
              .contentWindow.postMessage(JSON.stringify(param), "*");
          } else if (type == "storage") {
            const param = {
              key: "bk",
              type: "storage",
              from: "wxt",
              params: vm.spaceCapacity,
            };
            console.log("param----", param);
            document
              .getElementById("addLectureIframe")
              .contentWindow.postMessage(JSON.stringify(param), "*");
          } else if (type === "closeDialog") {
            console.log("关闭弹窗消息");
            // 关闭弹窗消息
            vm.addLectureUrl = "";
          } else if (type === "closeMask") {
            // 关闭父页面遮罩
            vm.isLoaded = true;
          } else if (type === "selectNode") {
            vm.handleSubmit(
              params.folderId || params.parentId,
              params.folderName,
              true
            );
            // 选择节点（加备课）
            vm.addLectureUrl = "";
          }
        }
        // }
      });
    },
    handleShowFileTree() {
      if (!this.loginStatus) {
        this.$emit("toLogin");
        // this.toLogin();
        return;
      }
      // this.showFileTree = true;
      this.initAddLecture();
      this.changeShowAddBkTip(false);
      // this.showBkTip = false;
      this.textbook.noticeParentPageShowMask(true);
    },
    async handleSubmit(parentId, folderName) {
      if (this.isLoading) return;
      console.log("isLoading", this.isLoading);
      this.isLoading = true;
      const h = this.$createElement;
      this.$message({
        message: "处理中...",
      });
      // this.chooseNode = node;
      // let parentId =
      let data = await request.postJson(api.document.documentAddBk, {
        documentId: this.documentId,
        parentId,
        isXiaoBen: false,
      });

      // console.log("data", data);
      let result = data.result;
      if (result.success) {
        this.$message({
          type: "success",
          showClose: true,
          message: h("span", { style: { fontSize: "14px" } }, [
            `资料已成功加入【备课空间】${folderName}目录下`,
            h(
              "a",
              {
                attrs: {},
                style: {
                  textDecoration: "underline",
                  color: "#0057FF",
                  cursor: "pointer",
                  marginLeft: "20px",
                },
                on: {
                  click: () => {
                    this.handleJumpBkPage();
                  },
                },
              },
              "去查看"
            ),
          ]),
        });
        this.getBkInfo();
        // 加入备课成功以后重新获取备课空间列表
        // let courseId = this.currentResourceInfo.courseId;
        let findCurrentCourse = this.userCourses.find(
          (item) => item.courseId == this.currentResourceInfo.courseId
        );
        if (!findCurrentCourse) {
          // 重新查找用户课程更新课程
          this.textbook.getUserCourses();
        }
      } else {
        // result.message && this.$message(result.message);
        if (result.spaceCapacity) {
          // console.log("网校通发送空间超限参数信息",res);
          this.spaceCapacity = result.spaceCapacity || {};
          this.initAddLecture(true);
        }
        if (!data.state) {
          console.log("data", data);
          this.$emit("showErrorCodeStatus", data);
        }
      }
      this.isLoading = false;
    },
    handleJumpBkPage() {
      this.$router.push(
        `/bk?courseId=${this.currentResourceInfo.courseId}${
          this.$route.query.xep_flag === "1" ? "?xep_flag=1" : ""
        }`
      );
    },
    // 下载资料
    async handleDownloadSoft() {
      if (!this.loginStatus) {
        this.$emit("toLogin");
        return;
      }
      if (!this.roleStatus) {
        this.$emit("handleShowDownloadErrorVisible", {
          status: true,
          message:
            "亲爱的用户，您的账号暂无网校通权限。请您确认账号信息是否正确，并与学校管理员联系以获取更多帮助",
        });
        return;
      }
      this.$emit("handleDownLoad");
      // this.handleDownLoad();
    },
    async handleEdit() {
      if (!this.loginStatus) {
        this.$emit("toLogin");
        return;
      }
      if (!this.roleStatus) {
        this.$emit("handleShowDownloadErrorVisible", {
          status: true,
          message:
            "亲爱的用户，您的账号暂无网校通权限。请您确认账号信息是否正确，并与学校管理员联系以获取更多帮助",
        });
        // this.downloadErrorMessage =
        //   "亲爱的用户，您的账号暂无网校通权限。请您确认账号信息是否正确，并与学校管理员联系以获取更多帮助";
        // this.handleShowDownloadErrorVisible &&
        //   this.handleShowDownloadErrorVisible(true);
        return;
      }
      let data = await request.get(api.document.getDocumentOnlineEdit, {
        documentId: this.documentId,
        isXiaoBen: false,
      });
      // console.log("获取在线编辑", data);
      if (!data.state) {
        // this.$message(data.result.message);
        this.$emit("showErrorCodeStatus", data);
      } else {
        let url = data.result.editUrl;
        url = url.replace(
          /(isInsert=)[^=&?]+/,
          `$1${this.textbook.isInIframe ? "xep" : "wxt"}`
        );
        window.open(url);
      }
    },
    initAddLecture(isStorage = false) {
      this.isLoaded = false;
      const url = `https://${beikeHost}/add-lecture.html#/${
        isStorage ? "?type=storage" : ""
      }`;
      // const redirectUrl =
      //   "https://${beikeHost}/ibook/sso/redirect?url=" +
      //   encodeURIComponent(url);
      this.addLectureUrl = url;
    },
    async getBkInfo() {
      let { courseId } = this.currentResourceInfo;
      let lastSelectedFolder = await getUserFolderLastSelected({
        courseId,
      });
      this.chooseNode = lastSelectedFolder.result;
      this.defaultCheckedId = this.chooseNode.folderId;
    },
    initAddBkTipStatus() {
      let firstShowAddBkTip = localStorage.getItem(SHOW_ADD_BK_TIP) || false;
      // console.log("firstShowAddBkTip", firstShowAddBkTip);
      // if(!showAddBkTip){
      this.firstShowAddBkTip = this.showAddBkTip = !firstShowAddBkTip;
      // }
    },
    handleFeedbackDialogVisible(status = true) {
      if (!this.loginStatus) {
        this.toLogin();
        return;
      }
      if (!this.roleStatus) {
        this.$emit("handleShowDownloadErrorVisible", {
          status: true,
          message:
            "亲爱的用户，您的账号暂无网校通权限。请您确认账号信息是否正确，并与学校管理员联系以获取更多帮助",
        });
        return;
      }
      this.$emit("handleFeedbackDialogVisible", status);
    },
    modifyCollectedState(status) {
      this.$set(this.currentResourceInfo, "isFavorite", status);
      this.$emit("handleFavorite");
    },
    toLogin() {
      this.$emit("toLogin");
    },
    collectBtnDialog() {
      this.$emit("handleShowDownloadErrorVisible", {
        status: true,
        message:
          "亲爱的用户，您的账号暂无网校通权限。请您确认账号信息是否正确，并与学校管理员联系以获取更多帮助",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.album-footer {
  height: 66px;
  padding: 12px 20px;
  z-index: 2000;
  position: fixed;
  bottom: 0;
  right: 0;
  width: 50%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #eee;
  .footer-modal {
    position: absolute;
    top: -24px;
    height: 24px;
    left: 0;
    width: 100%;
    background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.8) 50.5%,
      #fff 100%
    );
  }
  &.large-footer {
    position: absolute;
    bottom: 0;
    left: 20px;
    width: calc(100% - 40px);
    height: 66px;
    right: 20px;
    background: #fff;
    z-index: 10;
    padding: 12px 20px;
    justify-content: flex-end;
    box-shadow: 0px -3px 10px 0px rgba(0, 0, 0, 0.05);
    .document-group-btn {
      // width: 100%;
      display: flex;
      // align-items: flex-end;
      align-items: center;
      justify-content: flex-end;
      .document-btn {
        // min-width: 150px;
        // width: 121px;
        // flex: 1;
        // width: 150px;
        white-space: nowrap;
        height: 42px;
        background: #0057ff;
        border-radius: 8px;
        border: 1px solid transparent;
        color: #fff;
        text-align: center;
        line-height: 42px;
        font-size: 14px;
        margin-right: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 50px;
        cursor: pointer;
        position: relative;

        &:hover {
          background: #669aff;
        }

        &.bk-btn {
          border: 1px solid #0057ff;
          background: #fff;
          color: #0057ff;
          position: relative;

          &:hover {
            background: #e5f7fe;
          }
        }

        &.review-btn {
          background: #ff6b00;

          &:hover {
            opacity: 0.6;
          }
        }

        &:last-child {
          margin-right: 0px;
        }
        &.download-btn {
          // width: auto;
          // padding: 0 20px;
        }
      }

      &.single-group-btn {
        // display: block;

        .document-btn {
          // margin-top: 21px;
          // float: right;
          // width: 150px;
          // flex: content;
        }
      }
    }
  }
}
.top-tag {
  position: absolute;
  top: -10px;
  right: -10px;
  height: 17px;
  line-height: 17px;
  background: #fe4509;
  border-radius: 17px 17px 17px 0px;
  padding: 0 5px;
  font-size: 12px;
  color: #fff;
  border: 1px solid #ffffff;
}
.bk-tip-box {
  .add-bk-tip {
    border-radius: 6px;
    display: flex;
    align-items: center;
    color: #fff;
    max-width: 100%;
    span {
      &.check-btn {
        display: inline-block;
        margin-left: 10px;
        width: 48px;
        cursor: pointer;
        text-align: center;
        line-height: 26px;
        height: 26px;
        background: #0057ff;
        border-radius: 4px;
        color: #fff;
        font-size: 14px;

        &:hover {
          background: #669aff;
        }
      }

      &.text {
        text-decoration: underline;
      }
    }
    &.first-add-bk-tip {
      span {
        &.text {
          text-decoration: none;
        }
      }
      i {
        width: 16px;
        height: 16px;
        margin-left: 10px;
        line-height: 16px;
        text-align: center;
        border-radius: 3px;
        cursor: pointer;
        &:hover {
          background: rgba(255, 255, 255, 0.2);
        }
      }
    }
  }
}
.bk-add-lecture {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 2000;
  iframe {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    &.bk-loaded {
      background: none;
    }
  }
}
.el-icon-loading {
  position: absolute;
  z-index: 1;
  transform: translate(-50%, -50%);
  left: 50%;
  top: 50%;
  color: white;
  font-size: 20px;
}
.user-operation {
  position: relative;
  color: #1a1a1a;
  font-size: 14px;
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-end;
  white-space: nowrap;
  span {
    margin-right: 24px;
    cursor: pointer;

    &:last-child {
      margin-right: 0;
    }

    &.tiaocuo-btn {
      border-radius: 4px;
      padding: 4px 6px;

      &:hover {
        background: #eff1f4;
        color: #0057ff;

        .iconfont {
          color: #0057ff;
        }
      }
    }
    &.shezhi {
      border-radius: 4px;
      padding: 4px 6px;

      &:hover {
        background: #eff1f4;
        color: #0057ff;

        .iconfont {
          color: #0057ff;
        }
      }
    }
  }

  i {
    font-size: 16px;
    color: #1a1a1a;
    margin-right: 4px;
  }
}
.document-operation-btn {
  display: flex;
  height: 100%;
  float: right;
  margin-left: 40px;
  .document-group-btn {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .document-btn {
      height: 42px;
      background: #0057ff;
      border-radius: 8px;
      border: 1px solid transparent;
      color: #fff;
      text-align: center;
      line-height: 42px;
      font-size: 14px;
      margin-right: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 20px;
      cursor: pointer;
      position: relative;

      &:hover {
        background: #669aff;
      }

      &.bk-btn {
        border: 1px solid #0057ff;
        background: #fff;
        color: #0057ff;
        position: relative;

        &:hover {
          background: #e5f7fe;
        }
      }

      &.review-btn {
        background: #ff6b00;

        &:hover {
          opacity: 0.6;
        }
      }

      &:last-child {
        margin-right: 0px;
      }
      &.download-btn {
        width: auto;
        padding: 0 20px;
      }
    }
  }
}
</style>
